import { css } from '@styled-system/css';
import { stack } from '@styled-system/patterns';
import { type FC } from 'react';

import { Button } from '@/shared/components/ui/Button';
import { Separator } from '@/shared/components/ui/Separator';

interface SettingsButtonItemProps {
  label: string;
  buttonText: string;
  handleClick: () => Promise<void>;
  disabled?: boolean;
  variant?: 'primary' | 'danger';
}

export const SettingsButtonItem: FC<SettingsButtonItemProps> = ({
  label,
  buttonText,
  handleClick,
  disabled = false,
  variant = 'primary',
}) => {
  const containerStyles = stack({
    direction: 'column',
    gap: 'sm',
  });

  const itemStyles = stack({
    direction: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  });

  const labelStyles = css({
    fontSize: 'sm',
    fontWeight: 'medium',
    color: 'font.primary',
  });

  const separatorStyles = css({
    w: '90%',
    alignSelf: 'end',
  });

  return (
    <div className={containerStyles}>
      <div className={itemStyles}>
        <span className={labelStyles}>{label}</span>
        <Button
          handleClick={handleClick}
          showLoader
          disabled={disabled}
          color={variant === 'danger' ? 'accent.red' : 'font.primary'}
        >
          {buttonText}
        </Button>
      </div>
      <Separator className={separatorStyles} />
    </div>
  );
};
